var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8963 3.41421C11.6774 2.63316 12.9437 2.63316 13.7248 3.41421L16.5532 6.24264C17.3342 7.02369 17.3342 8.29002 16.5532 9.07107L9.60476 16.0195C9.52246 16.1018 9.41404 16.1528 9.29817 16.1637L5.58247 16.5143C4.32207 16.6332 3.26968 15.566 3.40628 14.3074L3.80158 10.665C3.81388 10.5517 3.86452 10.446 3.94511 10.3654L10.8963 3.41421ZM11.6027 5.53631C11.9932 5.14579 12.6263 5.14579 13.0169 5.53631L14.4311 6.95053C14.8216 7.34105 14.8216 7.97422 14.4311 8.36474L13.7232 9.07263L10.8948 6.2442L11.6027 5.53631ZM9.47978 7.6592L5.9428 11.1962L5.52896 13.2615C5.3887 13.9614 6.00596 14.5787 6.70594 14.4384L8.77123 14.0246L12.3082 10.4876L9.47978 7.6592Z",
    fill: "#F05D63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.4227752e083c6689d583e502ec2b4788.svg";
export { ForwardRef as ReactComponent };